module.exports = __webpack_public_path__ + "static/diluc-d55cfc5223374df7b6efb7fd73781012.png";